export default __webpack_public_path__ + "static/media/nr.db42aefe.svg";